module.exports = __webpack_public_path__ + "static/media/296334.234e2d62.png";